<template>
    <b-modal lazy
             centered
             hide-footer
             hide-header
             no-close-on-backdrop
             :visible="visible"
             ref="modalObject">
        <div class="modal-title text-center"><h2>{{ $t("tlt.limitationalert") }}</h2></div>
        <div class="modal-body text-center">{{ $t("lbl.limitationalert") }}</div>
        <div class="float-lg-right">
            <b-button  variant="primary" v-on:click="onConfirm()">
                <span>{{ $t("btn.basic.ok") }}</span>
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "mmf-limitation-alert",
    data: function() {
        return {
        }
    },
    props: {
        isVisible: Boolean
    },
    computed: {
        visible() {
            return this.isVisible
        }
    },
    methods: {
      showModal() {
        this.$refs.modalObject.show();
      },
      hideModal: function() {
        this.$refs.modalObject.hide();
      },
      onConfirm: function(buttonId) {
          this.$emit("confirm", buttonId);
      }
    }
}
</script>